import { PHOTO_EDITOR_ACTIONS, UPLOAD_PHOTOS_DATA_ACTIONS } from '../action/photos/photos.constants'
import {Cover, Vector} from '../entity'
import { EditorState } from '../state'

const initialEditorState: EditorState = {
    photo: undefined,
    loadingStarted: undefined,
    covers: [],
    lastCoverId: -1,
    isToolsEnabled: false,
    tool: null,
    acceptCover: null,
}

export const editorReducer = (state: EditorState = initialEditorState, action: any): EditorState => {
    switch (action.type) {
        case PHOTO_EDITOR_ACTIONS.INITIALIZE:
            let array: Cover[] = []
            array = [...action.photo.metadata.covers]

            return { ...state, photo: action.photo, loadingStarted: undefined, covers: array, tool: null, isToolsEnabled: false, lastCoverId: -1 }
        case PHOTO_EDITOR_ACTIONS.UPDATE_COVER:
            if (action.from !== undefined) {
                for (let i = 0; i < state.covers.length; i++) {
                    if (state.covers[i].id === action.id) {
                        state.covers[i].startSecond = action.from;
                        state.covers[i].endSecond = action.from + action.length;
                    }
                }
            }

            if (action.x !== undefined && action.y !== undefined) {
                for (let i = 0; i < state.covers.length; i++) {
                    if (state.covers[i].id === action.id) {
                        if (state.covers[i].type === 3) {
                            const rect = getRect(state.covers[i].points!)
                            for (let j = 0; j < state.covers[i].points!.length; j++) {
                                if (state.covers[i].points![j].flags === '[SPACER]') {
                                    continue;
                                }
                                const xdif = state.covers[i].points![j].x - rect.left
                                const ydif = state.covers[i].points![j].y - rect.top
                                state.covers[i].points![j].x = action.x + xdif
                                state.covers[i].points![j].y = action.y + ydif
                                state.covers[i].position!.x = rect.left
                                state.covers[i].position!.y = rect.top
                            }
                        } else {
                            state.covers[i].position!.x = action.x;
                            state.covers[i].position!.y = action.y;
                        }
                    }
                }
            }

            return { ...state }
        case PHOTO_EDITOR_ACTIONS.ADD_COVER:
            const coverArray = state.covers

            const indexOfCover = coverArray.findIndex((c) => {
                return c.id === action.cover.id
            })

            if (indexOfCover !== -1) {
                coverArray.splice(indexOfCover, 1)
            }

            coverArray.push({ ...action.cover, startSecond: action.from, endSecond: action.from + 1 })

            return { ...state, covers: coverArray, lastCoverId: action.cover.id }
        case PHOTO_EDITOR_ACTIONS.DELETE_COVER:
            const coversArray2 = state.covers

            const indexOfObject2 = coversArray2.findIndex((cover) => {
                return cover.id === action.id
            })

            if (indexOfObject2 !== -1) {
                coversArray2.splice(indexOfObject2, 1)
            }

            return { ...state, covers: coversArray2, lastCoverId: -1 }
        case PHOTO_EDITOR_ACTIONS.REMOVE_COVER:
            const coversArray = state.covers

            const indexOfObject = coversArray.findIndex((cover) => {
                return cover.id === state.lastCoverId
            })

            if (indexOfObject !== -1) {
                coversArray.splice(indexOfObject, 1)
            }

            return { ...state, covers: coversArray, lastCoverId: -1 }
        case PHOTO_EDITOR_ACTIONS.DELETE_ALL_COVER:
            return { ...state, covers: [], lastCoverId: -1 }
        case PHOTO_EDITOR_ACTIONS.CLEAR:
            return { ...state, photo: null, loadingStarted: undefined, covers: [], tool: null, isToolsEnabled: false, lastCoverId: -1 }
        case PHOTO_EDITOR_ACTIONS.IS_TOOLS_ENABLED:
            return { ...state, isToolsEnabled: action.enabled }
        case PHOTO_EDITOR_ACTIONS.SELECTED_TOOL:
            return { ...state, tool: action.tool }
        case PHOTO_EDITOR_ACTIONS.ACCEPT_COVER:
            return { ...state, acceptCover: action.acceptCover }

        case UPLOAD_PHOTOS_DATA_ACTIONS.UPLOAD_PHOTOS_DATA_ACTIONS_STARTED:
            return { ...state, loadingStarted: new Date() }
        case UPLOAD_PHOTOS_DATA_ACTIONS.UPLOAD_PHOTOS_DATA_ACTIONS_OK:
            return { ...state, loadingStarted: null }
        case UPLOAD_PHOTOS_DATA_ACTIONS.UPLOAD_PHOTOS_DATA_ACTIONS_FAILED:
            return { ...state, loadingStarted: undefined }
        default:
            return state
    }
}

const getRect = (points: Vector[]) => {
    let left: number = -1;
    let right: number = -1;
    let bottom: number = -1;
    let top: number = -1;

    for (const point of points) {
        if (point.flags === '[SPACER]') {
            continue;
        }
        if (left === -1 || left > point.x) {
            left = point.x;
        }
        if (top === -1 || top > point.y) {
            top = point.y;
        }
        if (right === -1 || right < point.x) {
            right = point.x;
        }
        if (bottom === -1 || bottom < point.y) {
            bottom = point.y;
        }
    }

    return { top, left, bottom, right }
}
